import React from "react";
import Widget from "../../features/widget/Widget";
import defaultLogoImg from "../../../../assests/home/school-logo.png";
import classes from "./DefaultLogoWidget.module.css";

const DefaultLogoWidget = () => {

    return (
        <Widget
            className={classes.DefaultLogoWidget}
            contentScrollable={false}
        >
            <div className={classes.DefaultLogoContent}>
                <img src={defaultLogoImg} alt="" className={classes.DefaultLogo} />
            </div>
        </Widget>
    );
};

export default DefaultLogoWidget;
